// extracted by mini-css-extract-plugin
export default {"screen-titles--title":"Carousel_screen-titles--title__xFhET","carousel":"Carousel_carousel__a8r0p","carousel__slides":"Carousel_carousel__slides__N9B10"};